import React, { Component } from "react";
import Tetris from "tetris-react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagicWandSparkles,
  faLineChart,
  faRotate,
  faPause,
  faPlay,
  faRotateRight,
  faAnglesDown,
  faCircleChevronLeft,
  faForwardFast,
  faCircleChevronRight,
  faCircleChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import "../stylesheet/TetrisGame.css";
import "../../stylesheet/style.css";

class TetrisGame extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tetrisScoreList: []
    };
    this.inputField = React.createRef();
  }

  componentDidMount() {
    this.props.fetchTetrisGamesScores();
  }

  renderHighScore(points) {
    const { data } = this.props;
    const scores =  _.orderBy(data, ['score', 'createAt'], ['desc', 'asc']);
    if(scores.length !== 0  && scores[0].score > points) {
      return (
        <div className="point-table">
          <h4>&#127942; {scores[0].name} ({scores[0].score})</h4>
        </div>
      );
    } else {
      return (
        <div className="point-table">
          <h4>&#127942; {points}</h4>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="tetris-game-main">
        <Tetris
          keyboardControls={{
            // Default values shown here. These will be used if no
            // `keyboardControls` prop is provided.
            down: "MOVE_DOWN",
            left: "MOVE_LEFT",
            right: "MOVE_RIGHT",
            space: "HARD_DROP",
            z: "FLIP_COUNTERCLOCKWISE",
            x: "FLIP_CLOCKWISE",
            up: "FLIP_CLOCKWISE",
            p: "TOGGLE_PAUSE",
            c: "HOLD",
            shift: "HOLD",
          }}
        >
          {({
            Gameboard,
            PieceQueue,
            points,
            linesCleared,
            state,
            controller,
          }) => (
            <div className="tetris-game-play">
              {state === "PAUSED" ? (
                <div className="game-over">
                  <p className="gameover__message">
                    Game Paused. Press resume button to start the game.
                  </p>
                  <button onClick={controller.resume}>Resume</button>
                </div>
              ) : null}
              <div className="tetris-game-board">
                <div className="tetris-details">
                  <div className="header">
                    <h1>TETRIS</h1>
                  </div>
                  <div className="points">
                    <p><FontAwesomeIcon
                          icon={faMagicWandSparkles}
                          size="1x"
                        /> {points}</p>
                    <p><FontAwesomeIcon
                          icon={faLineChart}
                          size="1x"
                        /> {linesCleared}</p>
                    {this.renderHighScore(points)}
                  </div>
                  
                  <div className="tetris-other-controller">
                    <div>
                      <button
                        style={
                          state === "PLAYING"
                            ? { backgroundColor: "#d33" }
                            : { backgroundColor: "#25754d" }
                        }
                        onClick={
                          state === "PAUSED"
                            ? controller.resume
                            : controller.pause
                        }
                      >
                        <FontAwesomeIcon
                          icon={state === "PAUSED" ? faPlay : faPause}
                          size="2x"
                        />
                      </button>
                      <button
                        style={{ backgroundColor: "#FF5733" }}
                        onClick={controller.restart}
                      >
                        <FontAwesomeIcon icon={faRotate} size="2x" />
                      </button>
                      <button onClick={controller.hardDrop}>
                        <FontAwesomeIcon icon={faAnglesDown} size="2x" />
                      </button>
                    </div>
                  </div>
                  <div className="tetris-arrow-controller">
                    <button className="rotate" onClick={controller.flipClockwise}>
                      <FontAwesomeIcon icon={faRotateRight} size="2x" />
                    </button>
                    <button className="left" onClick={controller.moveLeft}>
                      <FontAwesomeIcon icon={faCircleChevronLeft} size="2x" />
                    </button>
                    <button className="skip" onClick={controller.hold}>
                      <FontAwesomeIcon icon={faForwardFast} size="2x" />
                    </button>
                    <button className="right" onClick={controller.moveRight}>
                      <FontAwesomeIcon icon={faCircleChevronRight} size="2x" />
                    </button>
                    <button className="down" onClick={controller.moveDown}>
                      <FontAwesomeIcon icon={faCircleChevronDown} size="2x" />
                    </button>
                  </div>
                </div>
                <div className="tetris-play-board">
                  <h5>Game Board</h5>
                  <Gameboard />
                </div>
                <div className="tetris-up-next">
                  <h5>Up Next</h5>
                  <PieceQueue />
                </div>
                {state === "LOST" && (
                  <div className="game-over">
                    <p className="gameover__message">Game Over.... :(</p>
                    <Link className="gameover__close" to="/">
                      X
                    </Link>
                    {points !== 0 ?
                      <div className="app-form-group">
                        <input
                          className="app-form-control"
                          type="text"
                          placeholder="NAME"
                          ref={this.inputField}
                          name="name"
                          required
                        />
                        <button onClick={() => { this.submitScore(points); controller.restart() }}>SAVE & PLAY AGAIN</button>
                      </div>
                     : null
                    }
                    <button
                      style={points == 0 ? null : { display: "none" }}
                      onClick={controller.restart}
                    >
                      PLAY AGAIN
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </Tetris>
      </div>
    );
  }

  submitScore = (props) => {
    const { addTetrisGameScore } = this.props;
    let name = this.inputField.current.value;
    let score = props;

    if (name && score) {
      const createdAt = new Date().toString();
      const { tetrisScoreList } = this.state;
      tetrisScoreList.push({ createdAt, name, score });
      this.setState({ tetrisScoreList });
      addTetrisGameScore({
        name: name,
        score: score,
        createdAt: createdAt,
      });
      this.inputField.current.value = "";
    }
  };
}

const mapStateToProps = ({ data }) => {
  return {
    data,
  };
};

export default connect(mapStateToProps, actions)(TetrisGame);